import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { getBankQuickAssessmentThunk } from './thunk'

const initialState = {
  loading: true,
  data: {},
}

const slice = createSlice({
  name: 'companyAnalysis/financialAnalysis/bank/quickAssessment',
  initialState: initialState,
  reducers: {
    resetStoreBankQuickAssessment: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getBankQuickAssessmentThunk.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getBankQuickAssessmentThunk.fulfilled, (state, action) => {
      state.data = action.payload
      state.loading = false
    })
    builder.addCase(getBankQuickAssessmentThunk.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { resetStoreBankQuickAssessment } = slice.actions

export const selectLoading = (state) => state[slice.name].loading
export const selectData = (state) => state[slice.name].data

register(slice.name, slice.reducer)
